var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutralOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2194_4908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2607 33.837C57.7624 19.0583 48.6206 4.23918 33.842 0.737488C19.0633 -2.76421 4.24417 6.37757 0.742479 21.1562C-2.75922 35.9349 6.38256 50.754 21.1612 54.2557C35.9398 57.7574 50.759 48.6156 54.2607 33.837Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.049 36.027H14.9508C14.2074 36.027 13.6038 35.4234 13.6038 34.68C13.6038 33.9366 14.2074 33.3329 14.9508 33.3329H40.049C40.7924 33.3329 41.396 33.9366 41.396 34.68C41.396 35.4234 40.7924 36.027 40.049 36.027Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8854 22.8171C41.8854 24.4183 40.5892 25.7209 38.9816 25.7209C37.3741 25.7209 36.0779 24.4183 36.0779 22.8171C36.0779 21.2159 37.3804 19.9134 38.9816 19.9134C40.5828 19.9134 41.8854 21.2159 41.8854 22.8171Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9157 22.8171C18.9157 24.4183 17.6131 25.7209 16.0119 25.7209C14.4107 25.7209 13.1082 24.4183 13.1082 22.8171C13.1082 21.2159 14.4107 19.9134 16.0119 19.9134C17.6131 19.9134 18.9157 21.2159 18.9157 22.8171Z",
    fill: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2194_4908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralOff);
export default __webpack_public_path__ + "static/media/neutral_off.1a51ab313610e123569b1c990b428def.svg";
export { ForwardRef as ReactComponent };